import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { FORM_CONFIGS, PositionSpinOptions, SizeSpinOptions } from '@framework/workbench/drawer/ui/picture/picture-crop/config';
import { Form, NumberInputFrom } from '@tencent/wb-ext-form';
import { FormItemName, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { IPictureCropFeature } from './picture-crop-interface';

@Controller({ formItems: FORM_CONFIGS })
export class PictureCropController {
    constructor(@Loader(IPictureCropFeature) private loader: IDynamicLoader<IPictureCropFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.PICTURE_TAILOR, 'content')
    public renderTailor() {
        return this.feature.renderTailor();
    }

    @Form(FormItemName.PICTURE_POSITIOIN_WIDTH, 'value')
    public getPictureWidth(): number | string {
        const widthObj = { pictureWidth: this.feature.getPictureWidth() };
        const width = this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.PICTURE_POSITIOIN, widthObj);
        return this.feature.modifyShownValue(width, SizeSpinOptions.toFixed);
    }

    @Form(FormItemName.PICTURE_POSITIOIN_WIDTH, 'onChange')
    public changePictureWidth(value: number, from: NumberInputFrom): void {
        const { pictureWidth } = this.feature.getValidValue(
            { pictureWidth: value }, from,
            SizeSpinOptions.max, SizeSpinOptions.min,
        );
        this.feature.handlePictureWidth(pictureWidth, from);
    }

    @Form(FormItemName.PICTURE_POSITIOIN_HEIGHT, 'value')
    public getPictureHeight(): number | string {
        const heightObj = { pictureHeight: this.feature.getPictureHeight() };
        const height = this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.PICTURE_POSITIOIN, heightObj);
        return this.feature.modifyShownValue(height, SizeSpinOptions.toFixed);
    }

    @Form(FormItemName.PICTURE_POSITIOIN_HEIGHT, 'onChange')
    public changePictureHeight(value: number, from: NumberInputFrom): void {
        const { pictureHeight } = this.feature.getValidValue(
            { pictureHeight: value }, from,
            SizeSpinOptions.max, SizeSpinOptions.min,
        );
        this.feature.handlePictureHeight(pictureHeight, from);
    }

    @Form(FormItemName.PICTURE_POSITIOIN_OFFSET_X, 'value')
    public getPictureOffsetX(): number | string {
        const offsetXObj = { pictureOffsetX: this.feature.getPictureOffsetX() };
        const offsetX = this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.PICTURE_POSITIOIN, offsetXObj);
        return this.feature.modifyShownValue(offsetX, PositionSpinOptions.toFixed);
    }

    @Form(FormItemName.PICTURE_POSITIOIN_OFFSET_X, 'onChange')
    public changePictureOffsetX(value: number, from: NumberInputFrom): void {
        const { pictureOffsetX } = this.feature.getValidValue(
            { pictureOffsetX: value }, from,
            PositionSpinOptions.max, PositionSpinOptions.min,
        );
        this.feature.handlePictureOffsetX(pictureOffsetX, from);
    }

    @Form(FormItemName.PICTURE_POSITIOIN_OFFSET_Y, 'value')
    public getPictureOffsetY(): number | string {
        const offsetYObj = { pictureOffsetY: this.feature.getPictureOffsetY() };
        const offsetY = this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.PICTURE_POSITIOIN, offsetYObj);
        return this.feature.modifyShownValue(offsetY, PositionSpinOptions.toFixed);
    }

    @Form(FormItemName.PICTURE_POSITIOIN_OFFSET_Y, 'onChange')
    public changePictureOffsetY(value: number, from: NumberInputFrom): void {
        const { pictureOffsetY } = this.feature.getValidValue(
            { pictureOffsetY: value }, from,
            PositionSpinOptions.max, PositionSpinOptions.min,
        );
        this.feature.handlePictureOffsetY(pictureOffsetY, from);
    }

    @Form(FormItemName.CROP_POSITIOIN_WIDTH, 'value')
    public getCropWidth(): number | string {
        const widthObj = { cropWidth: this.feature.getCropWidth() };
        const width = this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.PICTURE_POSITIOIN, widthObj);
        return this.feature.modifyShownValue(width, SizeSpinOptions.toFixed);
    }

    @Form(FormItemName.CROP_POSITIOIN_WIDTH, 'onChange')
    public changeCropWidth(value: number, from: NumberInputFrom): void {
        const { cropWidth } = this.feature.getValidValue(
            { cropWidth: value }, from,
            SizeSpinOptions.max, SizeSpinOptions.min,
        );
        this.feature.handleCropWidth(cropWidth, from);
    }

    @Form(FormItemName.CROP_POSITIOIN_HEIGHT, 'value')
    public getCropHeight(): number | string {
        const heightObj = { cropHeight: this.feature.getCropHeight() };
        const height = this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.PICTURE_POSITIOIN, heightObj);
        return this.feature.modifyShownValue(height, SizeSpinOptions.toFixed);
    }

    @Form(FormItemName.CROP_POSITIOIN_HEIGHT, 'onChange')
    public changeCropHeight(value: number, from: NumberInputFrom): void {
        const { cropHeight } = this.feature.getValidValue(
            { cropHeight: value }, from,
            SizeSpinOptions.max, SizeSpinOptions.min,
        );
        this.feature.handleCropHeight(cropHeight, from);
    }

    @Form(FormItemName.CROP_POSITIOIN_LEFT, 'value')
    public getCropLeft(): number | string {
        const leftObj = { cropLeft: this.feature.getCropLeft() };
        const left = this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.PICTURE_POSITIOIN, leftObj);
        return this.feature.modifyShownValue(left, PositionSpinOptions.toFixed);
    }

    @Form(FormItemName.CROP_POSITIOIN_LEFT, 'onChange')
    public changeCropLeft(value: number, from: NumberInputFrom): void {
        const { cropLeft } = this.feature.getValidValue(
            { cropLeft: value }, from,
            PositionSpinOptions.max, PositionSpinOptions.min,
        );
        this.feature.handleCropLeft(cropLeft, from);
    }

    @Form(FormItemName.CROP_POSITIOIN_TOP, 'value')
    public getCropTop(): number | string {
        const topObj = { cropTop: this.feature.getCropTop() };
        const top = this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.PICTURE_POSITIOIN, topObj);
        return this.feature.modifyShownValue(top, PositionSpinOptions.toFixed);
    }

    @Form(FormItemName.CROP_POSITIOIN_TOP, 'onChange')
    public changeCropTop(value: number, from: NumberInputFrom): void {
        const { cropTop } = this.feature.getValidValue(
            { cropTop: value }, from,
            PositionSpinOptions.max, PositionSpinOptions.min,
        );
        this.feature.handleCropTop(cropTop, from);
    }

    @Form(FormItemName.PICTURE_POSITIOIN_WIDTH, 'shouldDisabled')
    @Form(FormItemName.PICTURE_POSITIOIN_HEIGHT, 'shouldDisabled')
    @Form(FormItemName.PICTURE_POSITIOIN_OFFSET_X, 'shouldDisabled')
    @Form(FormItemName.PICTURE_POSITIOIN_OFFSET_Y, 'shouldDisabled')
    public shouldPicturePositionDisabled(): boolean {
        return this.feature.shouldPicturePositionDisabled();
    }
}
